import { Controller } from "@hotwired/stimulus";

// Zet bij een klik een spinner in de knop of link en schakelt hem uit, zodat je niet twee
// keer verstuurt.
//
// De oorspronkelijke tekst gaat in een data-attribuut en niet in een variabele in het
// geheugen. Reden: Turbo bewaart een momentopname van de pagina bij het weggaan, en die
// wordt genomen terwijl de spinner nog draait. Bij een formulier valt dat mee, want
// turbo:submit-end herstelt de knop op tijd, maar bij een link komt die gebeurtenis nooit.
// Kwam je dan terug, dan stond de spinner bevroren in de knop -- en erger: connect() bewaarde
// die spinner als "de oorspronkelijke inhoud", waarna de knop nooit meer zijn tekst terugkreeg.
// Een attribuut reist mee in die momentopname, dus daarmee kan de knop zichzelf herstellen.
export default class extends Controller {
  static values = { with: String }

  connect() {
    if (this.element.dataset.originalLabel === undefined) {
      this.element.dataset.originalLabel = this.element.innerHTML
    } else {
      // Uit een bewaarde momentopname teruggekomen, mogelijk met de spinner er nog in.
      this.reset()
    }

    this.boundReset = this.reset.bind(this)
    document.addEventListener('turbo:submit-end', this.boundReset)

    // Luister naar invalid events op het formulier (front-end validatie)
    const formId = this.element.getAttribute('form')
    this.form = formId ? document.getElementById(formId) : this.element.closest('form')

    if (this.form) {
      this.boundResetOnInvalid = this.reset.bind(this)
      this.form.addEventListener('invalid', this.boundResetOnInvalid, true)
    }
  }

  disconnect() {
    document.removeEventListener('turbo:submit-end', this.boundReset)
    if (this.form) {
      this.form.removeEventListener('invalid', this.boundResetOnInvalid, true)
    }
  }

  reset() {
    this.element.innerHTML = this.element.dataset.originalLabel
    delete this.element.dataset.disabled
  }

  // doesn't seem to work with input type="submit".
  // please use the button element instead.
  handle(event) {
    const element = event.target

    if (element.dataset.disabled) {
      event.preventDefault()
    } else {
      element.dataset.disabled = true
      element.innerHTML = this.withValue
    }
  }
}
